import { render, staticRenderFns } from "./UserNameEmail.vue?vue&type=template&id=455fa52f&scoped=true&"
import script from "./UserNameEmail.vue?vue&type=script&lang=js&"
export * from "./UserNameEmail.vue?vue&type=script&lang=js&"
import style0 from "./UserNameEmail.vue?vue&type=style&index=0&id=455fa52f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fa52f",
  null
  
)

export default component.exports